import capitalize from 'lodash/capitalize'

export interface INameObject {
  firstName: string
  lastName: string
}

/**
 * Return an object with firstName and lastName
 * @param {string} inputString
 */
export const getNamesFromInput = (inputString: string = ''): INameObject => {
  const [firstName = '', lastName = ''] = inputString.split(' ') || []
  return {
    firstName: capitalize(firstName),
    lastName: capitalize(lastName),
  }
}
